"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EinsteinDiscoveryScreen = void 0;
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../gen-src/Localize");
var EinsteinDiscovery_1 = require("../img/EinsteinDiscovery");
var AnalyticsExtensionsSettingsDialogStyles_1 = require("../styles/AnalyticsExtensionsSettingsDialogStyles");
var ScreenTypes_1 = require("../util/ScreenTypes");
var TestIds_1 = require("../util/TestIds");
var EnabledSuccessCheckmark = '✔';
var BackTick = '‹';
var params = {
    host: '',
    port: '',
    isAuthEnabled: false,
    isSecure: true,
    username: '',
    password: '',
    typeIndex: ScreenTypes_1.ScreenType.EinsteinDiscovery,
};
var EinsteinDiscoveryScreen = function (props) {
    var onSetConnection = props.onSetConnection, updateIsEnabled = props.updateIsEnabled, isEnabled = props.isEnabled;
    var _a = React.useState(isEnabled ? ScreenTypes_1.ScreenState.isEnabled : ScreenTypes_1.ScreenState.isDisabled), screenState = _a[0], setScreenState = _a[1];
    var renderSelectionButtonContent = function () {
        switch (screenState) {
            case ScreenTypes_1.ScreenState.isDisabled:
                return Localize_1.Messages.Enable();
            case ScreenTypes_1.ScreenState.isEnabled:
                return Localize_1.Messages.Disable();
            case ScreenTypes_1.ScreenState.isExecuting:
                return (React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryActivitySpinner },
                    React.createElement(widgets_1.ActivitySpinnerWidget, { testId: TestIds_1.ActivitySpinnerTestId, spinnerSize: widgets_1.ActivitySpinnerSize.Small, onDarkBackground: true })));
            default:
                return Localize_1.Messages.Enable();
        }
    };
    var handleEnable = function () {
        onSetConnection(params)
            .then(function (didSucceed) {
            if (didSucceed) {
                updateIsEnabled(true);
                setScreenState(ScreenTypes_1.ScreenState.isEnabled);
            }
            else {
                setScreenState(ScreenTypes_1.ScreenState.didError);
            }
        })
            .catch(function () {
            setScreenState(ScreenTypes_1.ScreenState.didError);
        });
    };
    var handleDisable = function () {
        updateIsEnabled(false);
    };
    var onSelectionClick = function () {
        setScreenState(ScreenTypes_1.ScreenState.isExecuting);
        if (screenState === ScreenTypes_1.ScreenState.isDisabled) {
            handleEnable();
        }
        else if (screenState === ScreenTypes_1.ScreenState.isEnabled) {
            handleDisable();
        }
    };
    var getLowerLeftButtonContent = function () {
        if (screenState === ScreenTypes_1.ScreenState.isEnabled) {
            return Localize_1.Messages.Close();
        }
        else {
            return (React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryBackButtonContainer },
                React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.connectionScreenBackTickPadding }, BackTick),
                React.createElement("div", null, Localize_1.Messages.Back())));
        }
    };
    return (React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryScreenContainer },
        React.createElement(EinsteinDiscovery_1.EinsteinDiscovery, null),
        React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryInfoContainer },
            React.createElement("label", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryHeaderText }, Localize_1.Messages.EinsteinHeader()),
            React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryDescriptionTextContainer },
                React.createElement("label", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryDescriptionText }, Localize_1.Messages.EinsteinDiscoveryDescription())),
            React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryDisclaimerTextContainer },
                React.createElement("label", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryDisclaimerText }, Localize_1.Messages.LegalDisclaimer())),
            screenState === ScreenTypes_1.ScreenState.isEnabled ? (React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryEnabledSuccessContainer },
                React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryEnabledSuccessVerticalBar }),
                React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryEnabledSuccessCheckmark }, EnabledSuccessCheckmark),
                React.createElement("label", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryEnabledSuccessDescriptionText }, Localize_1.Messages.EinsteinEnabledText()))) : null),
        React.createElement("div", { className: AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryButtonsContainer },
            React.createElement("div", { className: isEnabled ? AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.withLargeSpaceHolder : AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.flex },
                React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, testId: TestIds_1.BackButtonTestId, onClick: isEnabled ? function () { return props.onClose(); } : function () { return props.onBack(ScreenTypes_1.ScreenType.Menu); } }, getLowerLeftButtonContent())),
            React.createElement("div", { className: isEnabled ? AnalyticsExtensionsSettingsDialogStyles_1.AnalyticsExtensionsSettingsDialogStyles.hide : undefined },
                React.createElement(widgets_1.ButtonWidget, { disabled: screenState === ScreenTypes_1.ScreenState.isExecuting || !props.savedAccessTokensEnabled, buttonType: widgets_1.ButtonType.Primary, testId: TestIds_1.SelectionButtonTestId, onClick: function () { return onSelectionClick(); } }, renderSelectionButtonContent())))));
};
exports.EinsteinDiscoveryScreen = EinsteinDiscoveryScreen;
//# sourceMappingURL=EinsteinDiscoveryScreen.js.map